import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { PosAppService } from "../services/pos.app.service";
import { PosLoginResponseService } from "../services/pos.login.response.service";
import { FnLocalStorageService, FnMenuDataService } from "foundation";
import { RouterServiceService } from "../services/router-service.service";

@Injectable({
  providedIn: 'root',
})
export class AppRoutingGuardService implements CanActivate {
  constructor(
    private router: Router,
    private routerService: RouterServiceService
  ) {
  
  //  console.log("appRouteGuardService called")
  }


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const menuItemID = route.data['menuItemID'];  // Expected menu item, e.g., "Menu_JPQL"
    //this.loginservice.loadMenuData();
   // console.log('wwwwwwww',this.routerService.getData('menuItemArray'));
    
    if (this.routerService.getData('menuItemArray').includes(menuItemID)) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }

  }

}
